module.exports = __webpack_public_path__ + "static/media/mopk_logo.448a7b9d.png";